/**
 * The three actions every input gives the jet (GDD §8): steer, throttle and fire. The attract-mode autopilot
 * produces the same input, so one simulation flies both (GDD §11).
 */
export interface PilotInput {
  /** −1 full left … +1 full right. */
  steer: number;
  /** −1 slowest (26 m/s) … 0 cruise (44) … +1 boost (62). */
  throttle: number;
  fire: boolean;
}

export const NEUTRAL: Readonly<PilotInput> = Object.freeze({ steer: 0, throttle: 0, fire: false });
